import type { Dispatch } from './utils/apiFetch.ts'
import { speFetchWorkspaceless } from './utils/apiFetch.ts'

const verifyEmailAddress = (dispatch: Dispatch<object>) =>
  speFetchWorkspaceless(dispatch, 'POST', '/user/verify-email-address.json')

const login = (values: $TSFixMe, dispatch: $TSFixMe) =>
  speFetchWorkspaceless(dispatch, 'POST', '/user/login.json', values)

const forgotPassword = (values: $TSFixMe, dispatch: $TSFixMe) =>
  speFetchWorkspaceless(dispatch, 'POST', '/user/forgot-password.json', values)

const signUp = (values: $TSFixMe, dispatch: $TSFixMe) =>
  speFetchWorkspaceless(dispatch, 'POST', '/user/signup.json', values)

export default {
  verifyEmailAddress,
  login,
  forgotPassword,
  signUp,
}
